import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    let _this = this;
    this.selectItems = []
    document.querySelectorAll(".c-main-search__select").forEach((item) => {
      this.selectItems.push(new Choices(item, {
        placeholder: false,
        searchEnabled: false,
        itemSelectText: '',
        dropdownDirection: "down"
      }));
    });

    const performance_kw = document.getElementById("performance_kw");
    const performance_le = document.getElementById("performance_le");

    performance_kw.addEventListener('change', function(e){
      document.getElementById("performance_unit").innerText = 'kW';
      document.getElementById("search_performance_type").value = 'kW';
      document.getElementsByName("search[performance_max]")[0].placeholder = document.getElementsByName("search[performance_max]")[0].getAttribute('data-kw-max');
      document.getElementsByName("search[performance_min]")[0].placeholder = document.getElementsByName("search[performance_min]")[0].getAttribute('data-kw-min');
    });


    performance_le.addEventListener('change', function(e){
      document.getElementById("performance_unit").innerText = 'LE';
      document.getElementById("search_performance_type").value = 'LE';
      document.getElementsByName("search[performance_max]")[0].placeholder = document.getElementsByName("search[performance_max]")[0].getAttribute('data-hp-max');
      document.getElementsByName("search[performance_min]")[0].placeholder = document.getElementsByName("search[performance_min]")[0].getAttribute('data-hp-min');
    });

    let autoSubmit = document.getElementsByClassName('search-submit');
    autoSubmit.forEach((item)=> {
      item.addEventListener('focusout', (event) => {
        _this.triggerTurboSubmit();
      });
    });


    //document.getElementById('c-main-search-form').action = '/'
  }

  disconnect() {
    this.selectItems.forEach((item) => {
      item.destroy();
    });
  }

  resetForm() {
    document.getElementById('c-main-search-form').reset();
    this.selectItems.forEach((item) => {
      item.clearChoices();
    });
  }

  submitSearch() {
    document.getElementById('c-main-search-form').action = '/cars'
    document.getElementById('c-main-search-form').method = 'get'
    document.getElementById('c-main-search-form').submit();
  }

  triggerTurboSubmit() {
    document.getElementById("submit-main-form").click();
  }
}